import React, { Suspense, useState } from 'react';
import Row from 'antd/es/grid/row';
import Bonus from './Bonus';
import User from './User';
import useSelector from '../../util/hooks/useSelector';
import useDispatch from '../../util/hooks/useDispatch';
import LogoIcon from '../../assets/navbar/logo.png';
import LogoWinterIcon from '../../assets/navbar/logo_winter.png';

import { Link } from 'react-router-dom';
import CartIndicator from '../../app/cart/components/CartIndicator';
import classNames from 'classnames';
import { Button, Switch } from 'antd';
import { updateUserUI } from '../../app/user/action-creators';
import { AccountGroup } from '../../app/user/types';
import { TopBarSales } from '../icons/TopBarSales';
import { TopBarSupport } from '../icons/TopBarSupport';
import { TopBarOrders } from '../icons/TopBarOrders';
import { TopBarEtrn } from '../icons/TopBarEtrn';
import Support from './Support';

function TopBar() {
  const dispatch = useDispatch();
  const { user, decodedToken, userAccountList } = useSelector((state) => state.user);
  const onlineShop = decodedToken?.group === AccountGroup.SHOP || decodedToken?.group === AccountGroup.CARRIER;

  const [isEtrnOnboardingVisible, setIsEtrnOnboardingVisible] = useState<boolean>(() => (
    !localStorage.getItem('is_seen_etrn')
  ));

  const finishEtrnOnboarding = () => {
    localStorage.setItem('is_seen_etrn', 'true');
    setIsEtrnOnboardingVisible(false);
  };

  const isUserOwnerOfCurrentAccount = React.useMemo(() => {
    if (user && userAccountList) {
      const accountFromList = userAccountList.find(i => i.accountId === user.accountId);
      return accountFromList?.ownerId === user.userId;
    }
    return false;
  }, [user, userAccountList])

  return (
    <Row className={classNames("gx-w-100 gx-align-items-center custom-navbar gx-ml-auto gx-mr-auto is-container-slim")}>
      <div className="gx-d-flex gx-align-items-center gx-mr-auto">
        <Link to="/" className='gx-d-flex gx-align-items-center gx-justify-content-center custom-navbar__logo'>
          <img src={LogoIcon} alt="logo"/>
        </Link>
        {
          window.location.pathname !== '/'
          ?
          <div className="gx-d-flex gx-align-items-center">
            <Link to="/" className="custom-navbar__global-link">
              По России и ЕАЭС
            </Link>
            <Link to="/" className="custom-navbar__global-link">
              Международная доставка
            </Link>
             <Link to="/?tab=cars" className="custom-navbar__global-link">
              Специальные режимы
            </Link>
            <div className="gx-position-relative gx-d-flex gx-align-items-center">
              <Link to="/etrn" className="custom-navbar__global-link" onClick={finishEtrnOnboarding}>
                ЭТрН
              </Link>
              {isEtrnOnboardingVisible && (
                <>
                  <div
                    className="custom-navbar__etrn-onboarding-overlay"
                    role="presentation"
                    onClick={finishEtrnOnboarding}
                  />
                  <div className="custom-navbar__etrn-onboarding">
                    <div className="custom-navbar__etrn-onboarding-text">
                      Узнайте как можно работать с ЭТрН в Белка Пост
                    </div>
                    <Button
                      type="primary"
                      size="small"
                      className="custom-navbar__etrn-onboarding-btn"
                      onClick={finishEtrnOnboarding}
                    >
                      Отлично
                    </Button>
                  </div>
                </>
              )}
            </div>
            {
              onlineShop
              &&
              <div className="custom-navbar__global-link">
                Интернет магазины
              </div>
              ||
              null
            }
          </div>
          :
          null
        }
      </div>
      <div className="gx-d-flex gx-align-items-center gx-ml-auto">
        <div className="gx-d-flex gx-align-items-center">
          {/* <div title="Эксклюзивные скидки" className="gx-d-flex gx-align-items-center gx-position-relative custom-navbar__menu-item gx-text-nowrap is-soon">
            <TopBarSales/>
            {window.location.pathname !== '/' ? null : 'Эксклюзивные скидки'}
            <div className={classNames("gx-position-absolute custom-navbar__soon", { "is-only-icon": window.location.pathname !== '/' })}>
              Скоро
            </div
          </div> */}
          <Suspense fallback={null}>
            <Support />
          </Suspense>
          <Link to="/orders" title="Мои заказы" className="gx-d-flex gx-align-items-center gx-position-relative custom-navbar__menu-item gx-text-nowrap">
            <TopBarOrders/>
            {window.location.pathname !== '/' ? null : 'Мои заказы'}
          </Link>
          { window.location.pathname === '/' && (
            <div className="gx-position-relative">
              <Link
                to="/etrn"
                title="ЭТрН"
                className="gx-d-flex gx-align-items-center gx-position-relative custom-navbar__menu-item gx-text-nowrap"
                onClick={finishEtrnOnboarding}
              >
                <TopBarEtrn/>
                ЭТрН
              </Link>
              {isEtrnOnboardingVisible && (
                <>
                  <div
                    className="custom-navbar__etrn-onboarding-overlay"
                    role="presentation"
                    onClick={finishEtrnOnboarding}
                  />
                  <div className="custom-navbar__etrn-onboarding">
                    <div className="custom-navbar__etrn-onboarding-text">
                      Узнайте как можно работать с ЭТрН в Белка Пост
                    </div>
                    <Button
                      type="primary"
                      size="small"
                      className="custom-navbar__etrn-onboarding-btn"
                      onClick={finishEtrnOnboarding}
                    >
                      Отлично
                    </Button>
                  </div>
                </>
              )}
            </div>
          ) }
          <Suspense fallback={null}>
            <CartIndicator isGlobalMenuShown={window.location.pathname !== '/'}/>
          </Suspense>
        </div>
        {
          isUserOwnerOfCurrentAccount
          &&
          <Suspense fallback={null}>
            <Bonus/>
          </Suspense>
          ||
          null
        }

        <Suspense fallback={null}>
          <User />
        </Suspense>
      </div>
    </Row>
  );
}

export default TopBar;
